import styled from "styled-components"

import {Input} from "@irati/ui/src/FormItem"
import {minWidthMedia} from "@irati/ui/src/global/media"

export const StyledInput = styled(Input)`
  width: 75%;
  ${minWidthMedia.desktop`
    width: 50%;
  `}
`
